/* lua.js generated code 0.3.0 */

/**
 * 道具id映射
 */
let GamePropIdMap = {
    [GamePropIds.kEnergyInf_10Min]: GamePropIds.kUnlimitedenergy_10,
}

function getMappedPropId(propId) {
    return GamePropIdMap[propId] || propId;
}

 // 这个类创建一些用于UI元素的小东西 属于一个实用工具
// 虽然算是个Util 但和目录中的Util的意义不同 因此放在了这里
UIItemBuilder = xClass("UserItemBuilder")
/*UIItemBuilder.createPropIcon = function (propId) {
    FrameLoader.loadImageWithPlist("cocos/properties.plist")
    var spriteFrame = cc.spriteFrameCache.getSpriteFrame("properties/prop_" + tostring(propId) + ".png")
    if (spriteFrame) {
        // WARN: maybe multi result
        return cc.Sprite.createWithSpriteFrame(spriteFrame)
    } else {
        // TODO: 创建一个问号返回
        // WARN: maybe multi result
        return cc.Sprite.create()
    }
}*/
// 背包优化时加的，这个new的版本统一了限时道具的时间显示，如果不需要可以用下边那个老版本
UIItemBuilder.createPropIconNew = function (propId, expireTime, notCountdown) {
    let self = this
    if (UserPropData.isTempProp(propId)) {
        // WARN: maybe multi result
        return UIItemBuilder.createPropIconWithTemp(propId)
    } else if (UserPropData.isTimeProp(propId)) {
        // WARN: maybe multi result
        if (UserPropData.isBagInfiniteProp(propId)){
            return UIItemBuilder.createPropIconWithTimeAndInfinite(propId, expireTime, notCountdown)
        }
        return UIItemBuilder.createPropIconWithTime(propId, expireTime, notCountdown)
    } else if (UserPropData.isInfiniteProp(propId)) {
        // WARN: maybe multi result
        return UIItemBuilder.createPropIconWithInfinite(propId)
    } else {
        // WARN: maybe multi result
        return UIItemBuilder.createPropIconWithoutTag(propId)
    }
}

UIItemBuilder.createItemDress = function (propId) {

    // 读取装扮配置信息 根据信息显示 头像框、名片夹 以及限时标记

    let item = cc.Node.create()
    item.setContentSize(96,96)
    item.setAnchorPoint(0.5, 0.5)
    let msg = DressManager.getInstance().getDressMsg(propId)
    let itemIcon
    if (msg.type == GameDressTypes.kHeadFrame){
        itemIcon =  DressManager.getInstance().createHeadFrame(propId)
        itemIcon.scale = 0.8
        itemIcon.setPosition(item.width/2, item.height/2)
        item.addChild(itemIcon)
    }else if (msg.type == GameDressTypes.kNameEffect){
        itemIcon = ccui.Text.create("", "Arail", 46)
        item.addChild(itemIcon)
        itemIcon.setPosition(item.width/2, item.height/2)
        UIUtils.createNameWithUserShow(itemIcon, "字效", 200, null, {nameEffect: propId})
    }else if (propId == GamePropIds.kNameCard || propId == GamePropIds.kNameDiamond){
        itemIcon = UIItemBuilder.createPropIconWithoutTag(propId)
        itemIcon.setPosition(item.width/2, item.height/2)
        item.addChild(itemIcon)
    }

    // msg.expire_time = Localhost.time()
    if (msg && (msg.expire_time > 0 || msg.expire_type)){
        let timeTag = UIItemBuilder.createTimeTag(null, true, true)
        timeTag.setPosition(cc.p(item.width/2, 10))
        item.addChild(timeTag)
        item.time = timeTag
    }

    return item
}

UIItemBuilder.createPropIcon = function (propId, expireTime, notCountdown) {
    let self = this
    if (UserPropData.isDressUp(propId)) {
        // WARN: maybe multi result
        return UIItemBuilder.createItemDress(propId)
    } else if (UserPropData.isTempProp(propId)) {
        // WARN: maybe multi result
        return UIItemBuilder.createPropIconWithTemp(propId)
    } else if (UserPropData.isInfinitePreProp(propId)) {
        // WARN: maybe multi result
        return UIItemBuilder.createInfiniteIconWithTime(propId, expireTime, notCountdown)
    } else if (UserPropData.isTimeProp(propId)) {
        // WARN: maybe multi result
        return UIItemBuilder.createPropIconWithTime(propId, expireTime, notCountdown)
    } else if (UserPropData.isInfiniteProp(propId)) {
        // WARN: maybe multi result
        return UIItemBuilder.createPropIconWithInfinite(propId)
    } else {
        // WARN: maybe multi result
        return UIItemBuilder.createPropIconWithoutTag(propId)
    }
}
// 无限次数限时可叠加道具
UIItemBuilder.createPropIconWithTimeAndInfinite = function (propId, expireTime, notCountdown, metaPropId){
	if (notCountdown == null) {
		notCountdown = true // 默认notCountdown
    }
    //let meta = MetaManager.getInstance().getPropMeta(propId) || MetaRef.create()

	expireTime = expireTime || UIItemBuilder.getExpireTime(propId, notCountdown)
	var sprite = null
    if (metaPropId != null){
        sprite = this.createPropIconWithoutTag(metaPropId)
    }else{
        sprite = this.createPropIconWithoutTag(propId)
    }
	sprite.setCascadeOpacityEnabled(true)
	sprite.noneNum = true // 这里定义不显示道具旁边的 "x1"

	FrameLoader.loadImageWithPlist("cocos/bag_prop_tag.plist")
	var time = UIItemBuilder.createUnlimitTimeTag(expireTime, notCountdown)
	time.setPosition(cc.p(46, 10))
	sprite.addChild(time)
	sprite.time = time
	return sprite
}
UIItemBuilder.createPropIconWithoutTag = function (propId) {
    propId = getMappedPropId(propId);
    FrameLoader.loadImageWithPlist("cocos/properties.plist")
    let spriteFrame = cc.spriteFrameCache.getSpriteFrame("properties/prop_" + tostring(propId) + ".png")
    if (spriteFrame) {
        // WARN: maybe multi result
        return cc.Sprite.createWithSpriteFrame(spriteFrame)
    } else {
        // TODO: 创建一个问号返回
        // WARN: maybe multi result
        return cc.Sprite.create()
    }
}
UIItemBuilder.createInfiniteIconWithTime = function (propId, expireTime, notCountdown) {
    let self = this

    expireTime = expireTime || UserManager.getInstance().getFirstTimePropExpireTime(propId)

    let [ismetaprop, metaPropId] = UserPropData.getInfiniteMetaPreProp(propId) //将传入道具id转换为元道具

    if (notCountdown == null){
        notCountdown = !ismetaprop
    }
    return UIItemBuilder.createPropIconWithTimeAndInfinite(propId, expireTime, notCountdown, metaPropId)
    // let sprite = self.createPropIconWithoutTag(metaPropId)
    // let icon = UIItemBuilder.createPropInfiniteTag()
    // icon.setScale(0.6)
    // icon.setPosition(10, 12)
    
    // let time = ccui.Scale9Sprite.createWithSpriteFrameName("properties/infinitypurplebg.png", cc.rect(30, 0, 45, 40))
    
    // time.setScale(0.5)
    // time.setPosition(cc.p(50, -23))
    // time.setContentSize(185, 65)
    // sprite.addChild(time)
    // sprite.addChild(icon)
    // let text = cc.Label.createWithSystemFont("请输入文本内容", "Arial", 17)

    // text._setFontStyle("bold");
    // text.setName("text")
    // text.setPosition(cc.p(60, 9))
    // // text.setScale(23)
    // sprite.addChild(text)

    // if (ismetaprop){ //元道具显示倒计时
    //     let node = cc.Node.create()
    //     sprite.addChild(node)
    //     node.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.CallFunc.create(function () {
    //         let now = Localhost.time()
    
    //         text.setString( UIUtils.formatCountDownTime(expireTime - now))
    
    //         let timeInMSec = expireTime - now
            
    //         if (timeInMSec < 0){
    //             text.setString("00:00")
    //             node.stopAllActions()
    //         }
    
    //     }), cc.DelayTime.create(1))))
    // }else {
    //     icon.x = 20
    //     time.width = 150
    //     text.setString( UIUtils.formatInfinitePrePropTime(MetaManager.getInstance().getPropMeta(propId).expireTime))
    // }

    // return sprite
}

UIItemBuilder.getExpireTime = function (propId, notCountdown) {
    var expireTime = 0
    if (notCountdown){
        let propMeta = MetaManager.getInstance().getPropMeta(propId)
        if (propMeta){
            if (propMeta.fixedExpireTime){
                expireTime = getEndTimeByTime(propMeta.fixedExpireTime)
            }else if (propMeta.expireType){
                expireTime = null //不要时间只要图标
            }else{
                expireTime = propMeta.expireTime + Localhost.time()
            }
        }
    }else{
        expireTime = UserManager.getInstance().getFirstTimePropExpireTime(propId, notCountdown)
    }
    return expireTime
}
UIItemBuilder.createPropIconWithTime = function (propId, expireTime, notCountdown) {
	if (notCountdown == null) {
        notCountdown = true
    }
    //var meta = MetaManager.getInstance().getPropMeta(propId) || MetaRef.create()
    expireTime = expireTime || UIItemBuilder.getExpireTime(propId, notCountdown)

    var sprite = UIItemBuilder.createPropIconWithoutTag(propId)
    sprite.setCascadeOpacityEnabled(true)

    var close = UIItemBuilder.createTimeTag(expireTime, notCountdown)
    close.setPosition(cc.p(46, 8))
    sprite.addChild(close)
    sprite.time = close

    return sprite
}
// 创建限时道具的下标
UIItemBuilder.createTimeTag = function(expireTime, notCountdown, onlyShowLimit){
	FrameLoader.loadImageWithPlist("cocos/bag_prop_tag.plist")
	var close = cc.CSLoader.createNode("cocos/bag_prop_time_tag.csb")
	var text = close.getChildByName("num")
	text.setName("text")
    text.setPositionY(text.getPositionY() - 8)
	var expireTag = close.getChildByName("expire")
    expireTag.setVisible(false)
    var expireTxt = expireTag.getChildByName("num")
    expireTxt.setPositionY(expireTxt.getPositionY() - 6)

	var remain = Math.max(0, Math.floor((expireTime - Localhost.time()) / 1000))
    if (onlyShowLimit){
		close.setScale(0.85)
		var bg = close.getChildByName("bag_limited")
		bg.setContentSize(cc.size(100, 31))
		text.setString("限时")
        var w = text.getContentSize().width
		text.setScale(Math.min(0.5, 65/text.getContentSize().width))
    }else if (notCountdown) { // 不计时,只展示限时时长
		close.setScale(0.85)
		var bg = close.getChildByName("bag_limited")
		bg.setContentSize(cc.size(100, 31))
		text.setString(UIUtils.formatPropTimeSimple(remain))
        var w = text.getContentSize().width
		text.setScale(Math.min(0.5, 65/text.getContentSize().width))
        //text.setScale(0.4)
    }else{
		var coundown = function(){
			var now = Localhost.time()
			var remain = Math.max(0, Math.floor((expireTime - now) / 1000))
			if (remain > 0) {
				text.setString(UIUtils.formatPropTime(remain))
				text.setScale(Math.min(0.5, 65/text.getContentSize().width))
            }
			else{
				close.getChildByName("bag_limited").setVisible(false)
				text.setVisible(false)
				close.getChildByName("expire").setVisible(true)
            }
        }
		coundown()
		var action = cc.RepeatForever.create(
			cc.Sequence.create(
				cc.CallFunc.create(coundown),
				cc.DelayTime.create(0.5)))
		action.setTag(99)
		close.runAction(action)
    }
	
	return close

}

// 创建无限限时道具的下标
UIItemBuilder.createUnlimitTimeTag = function(expireTime, notCountdown){
	FrameLoader.loadImageWithPlist("cocos/bag_prop_tag.plist")
	var time = cc.CSLoader.createNode("cocos/bag_prop_unlimit_tag.csb")
	var text = time.getChildByName("num")
    text.setPositionY(text.getPositionY() - 8)
	text.setName("text")
    var expireTag = time.getChildByName("expire")
    expireTag.setVisible(false)
    var expireTxt = expireTag.getChildByName("num")
    expireTxt.setPositionY(expireTxt.getPositionY() - 6)

	var remain = Math.max(0, Math.round((expireTime - Localhost.time()) / 1000))
    //不计时,只展示限时时长
	if (notCountdown) {
		time.setScale(0.85)
		var bg = time.getChildByName("bag_infinite")
		bg.setContentSize(cc.size(100, 31))
		text.setString(UIUtils.formatPropTimeSimple(remain))
        var w = text.getContentSize().width
		text.setScale(Math.min(0.5, 65/text.getContentSize().width))
        //text.setScale(0.4)
    }
	else{
		var coundown = function(){
			var now = Localhost.time()
			var remain = Math.max(0, Math.floor((expireTime - now) / 1000))
			if (remain > 0) {
				text.setString(UIUtils.formatPropTime(remain))
				text.setScale(Math.min(0.5, 65/text.getContentSize().width))
				//text.setScale(0.4)
            }
			else{
				time.getChildByName("bag_infinite").setVisible(false)
				text.setVisible(false)
				time.getChildByName("expire").setVisible(true)
            }
        }
		coundown()
		var action = cc.RepeatForever.create(
			cc.Sequence.create(
				cc.CallFunc.create(coundown),
				cc.DelayTime.create(0.5)))
		action.setTag(99)
		time.runAction(action)
    }
	return time
}
UIItemBuilder.createPropIconWithTemp = function (propId) {
    let self = this
    let sprite = self.createPropIconWithoutTag(propId)
    FrameLoader.loadImageWithPlist("cocos/gameScene.plist")
    // let temp = cc.Sprite.createWithSpriteFrameName("gameScene/game_prop_bar_temp_prop.png")
    let temp = cc.Sprite.createWithSpriteFrameName("homeScene/game_prop_bar_temp_prop.png") //关卡外部创建限时道具时候从homeScene取
    temp.setScale(0.8)
    temp.setPosition(cc.p(48, -10))
    temp.setName("propBarTempProp");
    sprite.addChild(temp)
    return sprite
}
// 引导用无限道具(仅限本关)
UIItemBuilder.createPropIconWithInfinite = function (propId) {
    let self = this
    let root = cc.Node.create()
    root.setCascadeOpacityEnabled(true)
    let propId1 = UserPropData.getPermanentPropId(propId)
    let sprite = self.createPropIconWithoutTag(propId1)
    sprite.setScale(0.74)
    root.addChild(sprite)
    root.sprite = sprite
    FrameLoader.loadImageWithPlist("cocos/gameScene.plist")
    let temp = cc.Sprite.createWithSpriteFrameName("gameScene/game_prop_bar_temp_prop.png")
    temp.setOpacity(0)
    temp.setScale(0.88)
    temp.setPosition(cc.p(0, -41))
    root.addChild(temp)
    root.temp = temp
    let label = UIItemBuilder.createPropInfiniteTag()
    label.setScale(0.96)
    label.setPosition(38, 38)
    root.addChild(label)
    root.infiTag = label
    return root
}
UIItemBuilder.createPropInfiniteTag = function () {
    let self = this
    
    // Toast.make(window.mini.getSystemPlatfrom() + ".." +SystemPlatform.IOS + ".." +SystemPlatform.Android)
    if (!isPlatformIOS()){
        let mask = cc.Sprite.createWithSpriteFrameName("properties/purpleinfinityicon.png")
        mask.setScale(0.94) 
        return mask
    }
    let root = cc.Node.create()
    root.setCascadeOpacityEnabled(true)
    let mask = cc.Sprite.createWithSpriteFrameName("properties/infinitymask.png")
    mask.setScale(0.94)
    let clipNode = cc.ClippingNode.create(mask)
    clipNode.setPosition(0, 0)
    clipNode.setAlphaThreshold(0)
    clipNode.setCascadeOpacityEnabled(true)
    root.addChild(clipNode)
    self.infLabel = clipNode
    let front = cc.Sprite.createWithSpriteFrameName("properties/infiniltyborderwhiteshadow.png")
    root.addChild(front)
    let radius = front.getContentSize().width / 2 * 0.85
    let colorBar = cc.Sprite.createWithSpriteFrameName("properties/infiniltybackgroundcolor.png")
    colorBar.setAnchorPoint(cc.p(0, 0.5))
    colorBar.setPosition(-radius, 0)
    clipNode.addChild(colorBar)
    root.colorBar = colorBar
    colorBar.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.MoveTo.create(5, cc.p(-colorBar.getContentSize().width / 2 - radius, 0)), cc.CallFunc.create(function () {
        colorBar.setPosition(-radius, 0)
    }))))
    return root
}
UIItemBuilder.createGoodsIcon = function (goodsId) {
    FrameLoader.loadImageWithPlist("cocos/properties.plist")
    var spriteFrame = cc.spriteFrameCache.getSpriteFrame("properties/goods_" + tostring(goodsId) + ".png")
    if (spriteFrame) {
        // WARN: maybe multi result
        return cc.Sprite.createWithSpriteFrame(spriteFrame)
    } else {
        // TODO: 创建一个问号返回
        var goodsMeta = MetaManager.getInstance().getGoodsMeta(goodsId)
        if (goodsMeta && goodsMeta.items && $len(goodsMeta.items) > 0) {
            var propId = goodsMeta.items[1].itemId
            // var spriteFrame = cc.spriteFrameCache.getSpriteFrame("properties/prop_" + tostring(propId) + ".png")
            // if (spriteFrame) {
            //     // WARN: maybe multi result
            //     return cc.Sprite.createWithSpriteFrame(spriteFrame)
            // }
            return UIItemBuilder.createProp(propId, 1,null,null,true)[0]
        }
        // WARN: maybe multi result
        return cc.Sprite.create()
    }
}

UIItemBuilder.createItemNumber = function (num, noneX) {
    if (num >= 10000) {
        var node = cc.Node.create()
        var numberText = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", (noneX && "" || "x") + Math.floor(num / 10000), cc.TEXT_ALIGNMENT_RIGHT)
        numberText.setAnchorPoint(cc.p(0, 0))
        numberText.setAdditionalKerning(-4)
        node.addChild(numberText)
        // var wanText = cc.Label.createWithBMFont("font/zzgftongxin_30_bluestroke.fnt", "万", cc.TEXT_ALIGNMENT_LEFT)
        var wanText = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", "万", cc.TEXT_ALIGNMENT_LEFT)
        wanText.setAnchorPoint(cc.p(0, 0))
        wanText.setScale(0.75)
        wanText.setPosition(numberText.getContentSize().width, 5)
        node.wanText = wanText
        node.addChild(wanText)
        node.setScale(0.8)
        node.setAnchorPoint(cc.p(0, 0))
        node.setContentSize(cc.size(numberText.getContentSize().width + wanText.getContentSize().width, numberText.getContentSize().height))
        return node
    } else {
        var numberText = cc.Label.createWithBMFont("font/berlinsansfb_30_bluestroke.fnt", (noneX && "" || "x") + num, cc.TEXT_ALIGNMENT_RIGHT)
        numberText.setAnchorPoint(cc.p(0, 0))
        numberText.setScale(0.8)
        numberText.setAdditionalKerning(-4)
        return numberText
    }
}
UIItemBuilder.createGoods = function (itemId, num) {
    var self = this
    var icon = UIItemBuilder.createGoodsIcon(itemId)
    if (num && num > 0) {
        var numText = UIItemBuilder.createItemNumber(num)
        numText.setAnchorPoint(cc.p(1, 0))
        numText.setPosition(100, 5)
        icon.addChild(numText)
    }
    return icon
}
UIItemBuilder.createUnderlineText = function (text, size, color) {
    color = color || cc.c4b(255, 255, 255, 255)
    var node = cc.Node.create()
    var label = cc.Label.createWithSystemFont(text, "Arial", size)
    label.setAnchorPoint(0, 0)
    label.setPosition(0, 0)
    node.addChild(label)
    var underline = cc.DrawNode.create()
    underline.setAnchorPoint(0, 0)
    underline.setPosition(0, -2)
    if (underline.setLineWidth) {
        underline.setLineWidth(1)
    }
    underline.color = color

    // FIXME: drawLine
    underline.drawRect(cc.p(0, 0), cc.p(label.getContentSize().width, 3), underline.color)
    node.addChild(underline)
    node.setContentSize(label.getContentSize())
    node.setTextColor = function (color) {
        label.setTextColor(color)
        underline.clear()
        // underline.color = ccc4fFromccc4b(color)
        underline.drawRect(cc.p(0, 0), cc.p(label.getContentSize().width, 3), underline.color)
    }
    node.setString = function (str) {
        label.setString(str)
        underline.clear()
        underline.drawRect(cc.p(0, 0), cc.p(label.getContentSize().width, 3), underline.color)
        node.setContentSize(label.getContentSize())
    }
    node.setAnchorPoint(0.5, 0.5)
    node.setTextColor(color)
    node.underline = underline
    return node
}
//-iconType:
//- 0(default) : icon scale 1, number is at corner and smaller
//- 1          : icon scale 0.8, number is at right side and larger 
//- 2          : icon scale 0.8, number is at right bottom and larger
UIItemBuilder.createProp = function (itemId, num, iconType, needTip, noneNum, noneX) {
    var icon = UIItemBuilder.createPropIcon(itemId)
    if (iconType === 1 ||iconType === 2 ) {
        icon.setScale(0.8)
    }
    // if (UserPropData.isDressUp(itemId)) noneNum = true
    var iconType = iconType || 0
    var propType = Math.floor((itemId || 0) / GamePropTypeConst)
    if (num && num > 0 && !noneNum && propType !== GamePropTypes.kPackage) {
        var numText = UIItemBuilder.createItemNumber(num, noneX)
        if (iconType === 0) {
            numText.setScale(1.1)
            numText.setAnchorPoint(cc.p(1, 0))
            numText.setPosition(110, -3)
        } else if (iconType === 1) {
            numText.setScale(1.2)
            numText.setAnchorPoint(cc.p(0, 0.5))
            numText.setPosition(80, 30)
        } else if (iconType === 2) {
            numText.setScale(1.2)
            numText.setAnchorPoint(0.5, 0.5)
            numText.setPosition(icon.getContentSize().width / 2, -10)
        }
        icon.numText = numText
        icon.addChild(numText, 0, 1)
        numText.setName("numText")
    }
    var onTouchFunc
    if (needTip) {
        var btn = UIButton.create(icon)
        onTouchFunc = function () {
            var scene = cc.Director.getInstance().getRunningScene()
            if (!scene) {
                return [null, null]
            }
            var ItemTip = require("clover/panel/component/bagpanel/ItemTipPopout")
            ItemTip.loadResource(function () {
                var tipBox = ItemTip.create()
                tipBox.setAnchorPoint(cc.p(0.5, 0))
                tipBox.setVisible(false)
                setTimeout(function () {
                    tipBox.setVisible(true)
                    var tipSize = tipBox.descBg.getContentSize()
                    var size = icon.getContentSize()
                    console.log("[iconsize] w:"+size.width+" h:"+size.height)
                    console.log("[iconsize] tipw:"+tipSize.width+" tiph:"+tipSize.height)
                    var wpos = cc.p(icon.convertToWorldSpace(cc.p(size.width / 2, size.height + tipSize.height + 20)))
                    wpos.x = Math.min(wpos.x, cc.Director.getInstance().getWinSize().width - tipSize.width / 2)
                    if (wpos.x < tipSize.width / 2) {
                        wpos.x = tipSize.width / 2
                    }
                    tipBox.setPosition(wpos)
                }, 2);
                tipBox.setItem(table([1, "itemId", itemId]), false)
                tipBox.onTouchOutside = function () {
                    tipBox.removeFromParent(true)
                }
                scene.addChild(tipBox, 9999)
            })
        }
        btn.on(UIButtonEvent.Tap, onTouchFunc)
    }
    return [icon, onTouchFunc]
}
PaymentEnumToPaymentIcon = table(
    [1, "wechat", "wechat"],
    [1, "alipay", "ali"],
    [1, "mi_alipay", "ali"],
    [1, "mi_wxpay", "wechat"],
    [1, "qihoo_wx", "wechat"],
    [1, "qihoo_ali", "ali"],
    [1, "vivo_ali", "ali"],
    [1, "vivo_wx", "wechat"],
    [1, "huawei", "huawei"],
    [1, "qq", "midas"]
)
UIItemBuilder.createPaymentIconBig = function (tag) {
    FrameLoader.loadImageWithPlist("cocos/payment_types.plist")
    if (__ANDROID && PlatformConfig.isSMSPayment(PlatformConfig.getPaymentTypeByTag(tag))) {
        // WARN: maybe multi result
        return cc.Sprite.createWithSpriteFrameName("payment_types/icon_ingame_big.png")
    } else if (PaymentEnumToPaymentIcon[tag]) {
        // WARN: maybe multi result
        return cc.Sprite.createWithSpriteFrameName("payment_types/icon_" + tostring(PaymentEnumToPaymentIcon[tag]) + "_big.png")
    }
    // TODO: 创建一个默认的支付图标
    var ret = cc.Sprite.create()
    ret.setContentSize(cc.size(84, 85))
    return ret
}
UIItemBuilder.createPaymentIconSmall = function (tag) {
    FrameLoader.loadImageWithPlist("cocos/payment_types.plist")
    if (__ANDROID && PlatformConfig.isSMSPayment(PlatformConfig.getPaymentTypeByTag(tag))) {
        // WARN: maybe multi result
        return cc.Sprite.createWithSpriteFrameName("payment_types/icon_ingame_small.png")
    } else if (PaymentEnumToPaymentIcon[tag]) {
        // WARN: maybe multi result
        return cc.Sprite.createWithSpriteFrameName("payment_types/icon_" + tostring(PaymentEnumToPaymentIcon[tag]) + "_small.png")
    }
    // TODO: 创建一个默认的支付图标
    var ret = cc.Sprite.create()
    ret.setContentSize(cc.size(84, 85))
    return ret
}
// 风车币各种数量资源
UIItemBuilder.ShopCashCommonRes = ["cocos/common_shop_cash.plist"]
UIItemBuilder.getCashSpriteFrame = function (price) {
    let num = 1
    if (price >= 500){
        num = 8
    }else if (price >= 300){
        num = 7
    }else if (price >= 150){
        num = 6
    }else if (price >= 100){
        num = 5
    }else if (price >= 60){
        num = 4
    }else if (price >= 30){
        num = 3
    }else if (price >= 7){
        num = 2
    }
    let spriteFrame = cc.spriteFrameCache.getSpriteFrame(`common_shop_cash/common_icon_gold_${num}.png`)
    if (!spriteFrame){
        cc.error("需要先行加载ShopCashCommonRes")
        spriteFrame = cc.spriteFrameCache.getSpriteFrame(`properties/prop_14.png`)
    }
    return spriteFrame
}
UIItemBuilder.createCashSprite = function (price) {
    let spriteFrame = UIItemBuilder.getCashSpriteFrame(price)

    return cc.Sprite.createWithSpriteFrameName(spriteFrame)
}
UIItemBuilder.ShopGiftCommonRes = ["cocos/common_shop_gift.plist"]
UIItemBuilder.getGiftSpriteFrame = function (lv) {
    let spriteFrame = cc.spriteFrameCache.getSpriteFrame(`common_shop_gift/common_shop_gift_lv${lv}.png`)
    if (!spriteFrame){
        cc.error(`需要先行加载ShopGiftCommonRes,或common_shop_gift_lv${lv}.png 不存在`)
        spriteFrame = cc.spriteFrameCache.getSpriteFrame(`properties/prop_14.png`)
    }
    return spriteFrame
}
